"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbeddedKnowledgeLocalDirectoryName = exports.GeneralValidationErrorId = exports.supportedLanguageCodes = exports.CEHCK_VALIDATION_RESULTS_INTERVAL_SECONDS = exports.STATIC_TABS_MAX_ITEMS = exports.TEAMS_APP_SHORT_NAME_MAX_LENGTH = exports.STATIC_TABS_TPL_EXISTING_APP = exports.getConfigurableTabsTplExistingAppBasedOnVersion = exports.CONFIGURABLE_TABS_TPL_EXISTING_APP_V2 = exports.CONFIGURABLE_TABS_TPL_EXISTING_APP = exports.COMPOSE_EXTENSIONS_TPL_EXISTING_APP = exports.getBotsTplExistingAppBasedOnVersion = exports.BOTS_TPL_EXISTING_APP_V2 = exports.BOTS_TPL_EXISTING_APP = exports.DEFAULT_DESCRIPTION = exports.DEFAULT_DEVELOPER = exports.DEFAULT_OUTLINE_PNG_FILENAME = exports.DEFAULT_COLOR_PNG_FILENAME = exports.OUTLINE_TEMPLATE = exports.COLOR_TEMPLATE = exports.MANIFEST_TEMPLATE_CONSOLIDATE = exports.APP_STUDIO_API_NAMES = exports.ErrorMessages = exports.Constants = exports.WEB_APPLICATION_INFO_V3 = exports.COMPOSE_EXTENSIONS_TPL_V3 = exports.COMPOSE_EXTENSIONS_TPL_M365_V3 = exports.getBotsTplBasedOnVersion = exports.BOTS_TPL_V4 = exports.BOTS_TPL_V3 = exports.getBotsTplForNotificationBasedOnVersion = exports.BOTS_TPL_FOR_NOTIFICATION_V4 = exports.BOTS_TPL_FOR_NOTIFICATION_V3 = exports.getBotsTplForCommandAndResponseBasedOnVersion = exports.BOTS_TPL_FOR_COMMAND_AND_RESPONSE_V4 = exports.BOTS_TPL_FOR_COMMAND_AND_RESPONSE_V3 = exports.getConfigurableTabsTplBasedOnVersion = exports.CONFIGURABLE_TABS_TPL_V4 = exports.CONFIGURABLE_TABS_TPL_V3 = exports.STATIC_TABS_TPL_V3 = void 0;
const tslib_1 = require("tslib");
const migrate_1 = require("../../migrate");
const semver_1 = tslib_1.__importDefault(require("semver"));
const AAD_STATE_KEY = migrate_1.ComponentNames.AadApp;
const TAB_STATE_KEY = migrate_1.ComponentNames.TeamsTab;
const BOT_STATE_KEY = migrate_1.ComponentNames.TeamsBot;
exports.STATIC_TABS_TPL_V3 = [
    {
        entityId: "index",
        name: "Personal Tab",
        contentUrl: `{{{state.${TAB_STATE_KEY}.endpoint}}}{{{state.${TAB_STATE_KEY}.indexPath}}}/tab`,
        websiteUrl: `{{{state.${TAB_STATE_KEY}.endpoint}}}{{{state.${TAB_STATE_KEY}.indexPath}}}/tab`,
        scopes: ["personal"],
    },
    {
        entityId: "index",
        name: "Dashboard",
        contentUrl: `{{{state.${TAB_STATE_KEY}.endpoint}}}{{{state.${TAB_STATE_KEY}.indexPath}}}/tab`,
        websiteUrl: `{{{state.${TAB_STATE_KEY}.endpoint}}}{{{state.${TAB_STATE_KEY}.indexPath}}}/tab`,
        scopes: ["personal"],
    },
];
exports.CONFIGURABLE_TABS_TPL_V3 = [
    {
        configurationUrl: `{{{state.${TAB_STATE_KEY}.endpoint}}}{{{state.${TAB_STATE_KEY}.indexPath}}}/config`,
        canUpdateConfiguration: true,
        scopes: ["team", "groupchat"],
    },
];
exports.CONFIGURABLE_TABS_TPL_V4 = [
    {
        configurationUrl: `{{{state.${TAB_STATE_KEY}.endpoint}}}{{{state.${TAB_STATE_KEY}.indexPath}}}/config`,
        canUpdateConfiguration: true,
        scopes: ["team", "groupChat"],
    },
];
function getConfigurableTabsTplBasedOnVersion(version) {
    const manifestVersion = semver_1.default.coerce(version);
    if (version === "devPreview" || (manifestVersion && semver_1.default.gte(manifestVersion, "1.17.0"))) {
        return exports.CONFIGURABLE_TABS_TPL_V4;
    }
    return exports.CONFIGURABLE_TABS_TPL_V3;
}
exports.getConfigurableTabsTplBasedOnVersion = getConfigurableTabsTplBasedOnVersion;
const BOT_ID_PLACEHOLDER = `{{state.${BOT_STATE_KEY}.botId}}`;
exports.BOTS_TPL_FOR_COMMAND_AND_RESPONSE_V3 = [
    {
        botId: BOT_ID_PLACEHOLDER,
        scopes: ["personal", "team", "groupchat"],
        supportsFiles: false,
        isNotificationOnly: false,
        commandLists: [
            {
                scopes: ["personal", "team", "groupchat"],
                commands: [
                    {
                        title: "helloWorld",
                        description: "A helloworld command to send a welcome message",
                    },
                ],
            },
        ],
    },
];
exports.BOTS_TPL_FOR_COMMAND_AND_RESPONSE_V4 = [
    {
        botId: BOT_ID_PLACEHOLDER,
        scopes: ["personal", "team", "groupChat"],
        supportsFiles: false,
        isNotificationOnly: false,
        commandLists: [
            {
                scopes: ["personal", "team", "groupChat"],
                commands: [
                    {
                        title: "helloWorld",
                        description: "A helloworld command to send a welcome message",
                    },
                ],
            },
        ],
    },
];
function getBotsTplForCommandAndResponseBasedOnVersion(version) {
    const manifestVersion = semver_1.default.coerce(version);
    if (version === "devPreview" || (manifestVersion && semver_1.default.gte(manifestVersion, "1.17.0"))) {
        return exports.BOTS_TPL_FOR_COMMAND_AND_RESPONSE_V4;
    }
    return exports.BOTS_TPL_FOR_COMMAND_AND_RESPONSE_V3;
}
exports.getBotsTplForCommandAndResponseBasedOnVersion = getBotsTplForCommandAndResponseBasedOnVersion;
exports.BOTS_TPL_FOR_NOTIFICATION_V3 = [
    {
        botId: BOT_ID_PLACEHOLDER,
        scopes: ["personal", "team", "groupchat"],
        supportsFiles: false,
        isNotificationOnly: false,
    },
];
exports.BOTS_TPL_FOR_NOTIFICATION_V4 = [
    {
        botId: BOT_ID_PLACEHOLDER,
        scopes: ["personal", "team", "groupChat"],
        supportsFiles: false,
        isNotificationOnly: false,
    },
];
function getBotsTplForNotificationBasedOnVersion(version) {
    const manifestVersion = semver_1.default.coerce(version);
    if (version === "devPreview" || (manifestVersion && semver_1.default.gte(manifestVersion, "1.17.0"))) {
        return exports.BOTS_TPL_FOR_NOTIFICATION_V4;
    }
    return exports.BOTS_TPL_FOR_NOTIFICATION_V3;
}
exports.getBotsTplForNotificationBasedOnVersion = getBotsTplForNotificationBasedOnVersion;
exports.BOTS_TPL_V3 = [
    {
        botId: BOT_ID_PLACEHOLDER,
        scopes: ["personal", "team", "groupchat"],
        supportsFiles: false,
        isNotificationOnly: false,
        commandLists: [
            {
                scopes: ["personal", "team", "groupchat"],
                commands: [
                    {
                        title: "welcome",
                        description: "Resend welcome card of this Bot",
                    },
                    {
                        title: "learn",
                        description: "Learn about Adaptive Card and Bot Command",
                    },
                ],
            },
        ],
    },
];
exports.BOTS_TPL_V4 = [
    {
        botId: BOT_ID_PLACEHOLDER,
        scopes: ["personal", "team", "groupChat"],
        supportsFiles: false,
        isNotificationOnly: false,
        commandLists: [
            {
                scopes: ["personal", "team", "groupChat"],
                commands: [
                    {
                        title: "welcome",
                        description: "Resend welcome card of this Bot",
                    },
                    {
                        title: "learn",
                        description: "Learn about Adaptive Card and Bot Command",
                    },
                ],
            },
        ],
    },
];
function getBotsTplBasedOnVersion(version) {
    const manifestVersion = semver_1.default.coerce(version);
    if (version === "devPreview" || (manifestVersion && semver_1.default.gte(manifestVersion, "1.17.0"))) {
        return exports.BOTS_TPL_V4;
    }
    return exports.BOTS_TPL_V3;
}
exports.getBotsTplBasedOnVersion = getBotsTplBasedOnVersion;
exports.COMPOSE_EXTENSIONS_TPL_M365_V3 = [
    {
        botId: BOT_ID_PLACEHOLDER,
        commands: [
            {
                id: "searchQuery",
                context: ["compose", "commandBox"],
                description: "Test command to run query",
                title: "Search",
                type: "query",
                parameters: [
                    {
                        name: "searchQuery",
                        title: "Search Query",
                        description: "Your search query",
                        inputType: "text",
                    },
                ],
            },
        ],
    },
];
exports.COMPOSE_EXTENSIONS_TPL_V3 = [
    {
        botId: BOT_ID_PLACEHOLDER,
        commands: [
            {
                id: "createCard",
                context: ["compose"],
                description: "Command to run action to create a Card from Compose Box",
                title: "Create Card",
                type: "action",
                parameters: [
                    {
                        name: "title",
                        title: "Card title",
                        description: "Title for the card",
                        inputType: "text",
                    },
                    {
                        name: "subTitle",
                        title: "Subtitle",
                        description: "Subtitle for the card",
                        inputType: "text",
                    },
                    {
                        name: "text",
                        title: "Text",
                        description: "Text for the card",
                        inputType: "textarea",
                    },
                ],
            },
            {
                id: "shareMessage",
                context: ["message"],
                description: "Test command to run action on message context (message sharing)",
                title: "Share Message",
                type: "action",
                parameters: [
                    {
                        name: "includeImage",
                        title: "Include Image",
                        description: "Include image in Hero Card",
                        inputType: "toggle",
                    },
                ],
            },
            {
                id: "searchQuery",
                context: ["compose", "commandBox"],
                description: "Test command to run query",
                title: "Search",
                type: "query",
                parameters: [
                    {
                        name: "searchQuery",
                        title: "Search Query",
                        description: "Your search query",
                        inputType: "text",
                    },
                ],
            },
        ],
        messageHandlers: [
            {
                type: "link",
                value: {
                    domains: ["*.botframework.com"],
                },
            },
        ],
    },
];
exports.WEB_APPLICATION_INFO_V3 = {
    id: `{{state.${AAD_STATE_KEY}.clientId}}`,
    resource: `{{{state.${AAD_STATE_KEY}.applicationIdUris}}}`,
};
class Constants {
}
exports.Constants = Constants;
Constants.MANIFEST_FILE = "manifest.json";
Constants.PLUGIN_NAME = "AppStudioPlugin";
Constants.BUILD_OR_PUBLISH_QUESTION = "build-or-publish";
Constants.INCLUDE_APP_MANIFEST = "include-app-manifest";
Constants.DEVELOPER_PORTAL_APP_PACKAGE_URL = "https://dev.teams.microsoft.com/apps/%s/app-package?login_hint=%s";
Constants.PUBLISH_GUIDE = "https://aka.ms/teamsfx-publish";
Constants.TEAMS_ADMIN_PORTAL = "https://aka.ms/teamsfx-mtac";
Constants.TEAMS_MANAGE_APP_DOC = "https://aka.ms/teamsfx-mtac-doc";
Constants.TEAMS_APP_ID = "teamsAppId";
Constants.TEAMS_APP_UPDATED_AT = "teamsAppUpdatedAt";
Constants.TEAMS_APP_ID_ENV = "TEAMS_APP_ID";
Constants.PERMISSIONS = {
    name: "Teams App",
    noPermission: "No permission",
    admin: "Administrator",
    operative: "Operative",
    type: "M365",
};
// HTTP headers are case insensitive. Axios lowercases all headers.
Constants.CORRELATION_ID = "x-correlation-id";
class ErrorMessages {
}
exports.ErrorMessages = ErrorMessages;
ErrorMessages.GetConfigError = (configName, plugin) => `Failed to get configuration value "${configName}" for ${plugin}.`;
ErrorMessages.GrantPermissionFailed = "Response is empty or user is not added.";
ErrorMessages.TeamsAppNotFound = (teamsAppId) => `Cannot find app with id: ${teamsAppId}. Maybe your current M365 account doesn't not have permission, or the app has already been deleted.`;
class APP_STUDIO_API_NAMES {
}
exports.APP_STUDIO_API_NAMES = APP_STUDIO_API_NAMES;
APP_STUDIO_API_NAMES.CREATE_APP = "create-app";
APP_STUDIO_API_NAMES.CREATE_AAD_APP = "create-aad-app";
APP_STUDIO_API_NAMES.GET_APP = "get-app";
APP_STUDIO_API_NAMES.LIST_APPS = "list-app";
APP_STUDIO_API_NAMES.DELETE_APP = "delete-app";
APP_STUDIO_API_NAMES.PUBLISH_APP = "publish-app";
APP_STUDIO_API_NAMES.GET_PUBLISHED_APP = "get-published-app";
APP_STUDIO_API_NAMES.UPDATE_PUBLISHED_APP = "update-published-app";
APP_STUDIO_API_NAMES.UPDATE_OWNER = "update-owner";
APP_STUDIO_API_NAMES.EXISTS_IN_TENANTS = "exists-in-tenant";
APP_STUDIO_API_NAMES.GET_APP_PACKAGE = "get-app-package";
APP_STUDIO_API_NAMES.VALIDATE_APP_PACKAGE = "validate-app-package";
APP_STUDIO_API_NAMES.CREATE_BOT = "create-bot";
APP_STUDIO_API_NAMES.GET_BOT = "get-bot";
APP_STUDIO_API_NAMES.LIST_BOT = "list-bot";
APP_STUDIO_API_NAMES.DELETE_BOT = "delete-bot";
APP_STUDIO_API_NAMES.UPDATE_BOT = "update-bot";
APP_STUDIO_API_NAMES.CREATE_API_KEY = "create-api-key";
APP_STUDIO_API_NAMES.UPDATE_API_KEY = "update-api-key";
APP_STUDIO_API_NAMES.GET_API_KEY = "get-api-key";
APP_STUDIO_API_NAMES.SUBMIT_APP_VALIDATION = "submit-app-validation";
APP_STUDIO_API_NAMES.GET_APP_VALIDATION_RESULT = "get-app-validation-result";
APP_STUDIO_API_NAMES.GET_APP_VALIDATION_REQUESTS = "get-app-validation-requests";
APP_STUDIO_API_NAMES.GET_OAUTH = "get-oauth";
APP_STUDIO_API_NAMES.CREATE_OAUTH = "create-oauth";
APP_STUDIO_API_NAMES.UPDATE_OAUTH = "update-oauth";
APP_STUDIO_API_NAMES.CHECK_SIDELOADING_STATUS = "check-sideloading-status";
/**
 * Config keys that are useful for generating remote app manifest
 */
exports.MANIFEST_TEMPLATE_CONSOLIDATE = "manifest.template.json";
exports.COLOR_TEMPLATE = "plugins/resource/appstudio/defaultIcon.png";
exports.OUTLINE_TEMPLATE = "plugins/resource/appstudio/defaultOutline.png";
exports.DEFAULT_COLOR_PNG_FILENAME = "color.png";
exports.DEFAULT_OUTLINE_PNG_FILENAME = "outline.png";
// Default values for the developer fields in manifest.
exports.DEFAULT_DEVELOPER = {
    name: "Teams App, Inc.",
    websiteUrl: "https://www.example.com",
    privacyUrl: "https://www.example.com/termofuse",
    termsOfUseUrl: "https://www.example.com/privacy",
};
// Default values for the description fields in manifest.
exports.DEFAULT_DESCRIPTION = {
    short: "Short description",
    full: "Full description",
};
exports.BOTS_TPL_EXISTING_APP = [
    {
        botId: "{{config.manifest.botId}}",
        scopes: ["personal", "team", "groupchat"],
        supportsFiles: false,
        isNotificationOnly: false,
        commandLists: [
            {
                scopes: ["personal", "team", "groupchat"],
                commands: [],
            },
        ],
    },
];
exports.BOTS_TPL_EXISTING_APP_V2 = [
    {
        botId: "{{config.manifest.botId}}",
        scopes: ["personal", "team", "groupChat"],
        supportsFiles: false,
        isNotificationOnly: false,
        commandLists: [
            {
                scopes: ["personal", "team", "groupChat"],
                commands: [],
            },
        ],
    },
];
function getBotsTplExistingAppBasedOnVersion(version) {
    const manifestVersion = semver_1.default.coerce(version);
    if (version === "devPreview" || (manifestVersion && semver_1.default.gte(manifestVersion, "1.17.0"))) {
        return exports.BOTS_TPL_EXISTING_APP_V2;
    }
    return exports.BOTS_TPL_EXISTING_APP;
}
exports.getBotsTplExistingAppBasedOnVersion = getBotsTplExistingAppBasedOnVersion;
exports.COMPOSE_EXTENSIONS_TPL_EXISTING_APP = [
    {
        botId: "{{config.manifest.botId}}",
        commands: [],
        messageHandlers: [
            {
                type: "link",
                value: {
                    domains: ["*.botframework.com"],
                },
            },
        ],
    },
];
exports.CONFIGURABLE_TABS_TPL_EXISTING_APP = [
    {
        configurationUrl: "{{config.manifest.tabConfigurationUrl}}",
        canUpdateConfiguration: true,
        scopes: ["team", "groupchat"],
    },
];
exports.CONFIGURABLE_TABS_TPL_EXISTING_APP_V2 = [
    {
        configurationUrl: "{{config.manifest.tabConfigurationUrl}}",
        canUpdateConfiguration: true,
        scopes: ["team", "groupChat"],
    },
];
function getConfigurableTabsTplExistingAppBasedOnVersion(version) {
    const manifestVersion = semver_1.default.coerce(version);
    if (version === "devPreview" || (manifestVersion && semver_1.default.gte(manifestVersion, "1.17.0"))) {
        return exports.CONFIGURABLE_TABS_TPL_EXISTING_APP_V2;
    }
    return exports.CONFIGURABLE_TABS_TPL_EXISTING_APP;
}
exports.getConfigurableTabsTplExistingAppBasedOnVersion = getConfigurableTabsTplExistingAppBasedOnVersion;
exports.STATIC_TABS_TPL_EXISTING_APP = [
    {
        entityId: "index",
        name: "Personal Tab",
        contentUrl: "{{config.manifest.tabContentUrl}}",
        websiteUrl: "{{config.manifest.tabWebsiteUrl}}",
        scopes: ["personal"],
    },
];
exports.TEAMS_APP_SHORT_NAME_MAX_LENGTH = 30;
exports.STATIC_TABS_MAX_ITEMS = 16;
// Check validation result interval
exports.CEHCK_VALIDATION_RESULTS_INTERVAL_SECONDS = 60;
/**
 * Language codes.
 */
exports.supportedLanguageCodes = [
    "ar-sa",
    "cs-cz",
    "da-dk",
    "de-at",
    "de-ch",
    "de-de",
    "de-li",
    "de-lu",
    "en-029",
    "en-au",
    "en-bz",
    "en-ca",
    "en-gb",
    "en-ie",
    "en-in",
    "en-jm",
    "en-my",
    "en-nz",
    "en-ph",
    "en-sg",
    "en-tt",
    "en-us",
    "en-za",
    "en-zw",
    "es-ar",
    "es-bo",
    "es-cl",
    "es-co",
    "es-cr",
    "es-do",
    "es-ec",
    "es-es",
    "es-gt",
    "es-hn",
    "es-mx",
    "es-ni",
    "es-pa",
    "es-pe",
    "es-pr",
    "es-py",
    "es-sv",
    "es-us",
    "es-uy",
    "es-ve",
    "fi-fi",
    "fr-be",
    "he-il",
    "hi-in",
    "fr-ca",
    "fr-ch",
    "fr-fr",
    "fr-lu",
    "fr-mc",
    "it-ch",
    "it-it",
    "ja-jp",
    "ko-kr",
    "nb-no",
    "nn-no",
    "nl-be",
    "nl-nl",
    "fil-ph",
    "pl-pl",
    "sk-sk",
    "hu-hu",
    "el-gr",
    "uk-ua",
    "pseudo",
    "fl-ip",
    "pt-br",
    "pt-pt",
    "ru-ru",
    "sv-fi",
    "sv-se",
    "tr-tr",
    "zh-cn",
    "zh-sg",
    "zh-hk",
    "zh-mo",
    "zh-tw",
    "th-th",
    "id-id",
    "ro-ro",
    "vi-vn",
    "lt-lt",
    "sl-si",
    "ca-es",
    "hr-hr",
    "et-ee",
    "bg-bg",
    "cy-gb",
    "is-is",
    "sr-latn-rs",
    "lv-lv",
    "ar",
    "cs",
    "da",
    "de",
    "en",
    "es",
    "fi",
    "fr",
    "he",
    "hi",
    "it",
    "ja",
    "ko",
    "nb",
    "nn",
    "nl",
    "fil",
    "pl",
    "sk",
    "hu",
    "el",
    "uk",
    "pseudo",
    "fl",
    "pt",
    "ru",
    "sv",
    "tr",
    "zh",
    "th",
    "id",
    "ro",
    "vi",
    "lt",
    "sl",
    "ca",
    "hr",
    "et",
    "bg",
    "cy",
    "is",
    "sr",
    "lv",
];
exports.GeneralValidationErrorId = "693c7aa7-4d76-40ec-8282-06410f5d1f76";
exports.EmbeddedKnowledgeLocalDirectoryName = "EmbeddedKnowledge";
//# sourceMappingURL=constants.js.map